import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { call } from "../lib/callFunction";
import { useAuth } from "../hooks/useAuth";

export function ImpersonationBanner() {
  const { impersonation } = useAuth();
  const [, navigate] = useLocation();
  const [left, setLeft] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!impersonation) return;
    const tick = () => {
      const ms = Math.max(0, impersonation.expiresAt - Date.now());
      const m = Math.floor(ms / 60000);
      const s = Math.floor((ms % 60000) / 1000);
      setLeft(`${m}:${String(s).padStart(2, "0")}`);
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [impersonation]);

  if (!impersonation) return null;

  async function act(fn: "extendImpersonation" | "endImpersonation") {
    setBusy(true);
    try {
      await call(fn, {}, { mutation: false });
      // "~" = absolute: this renders inside the /app nest, where a bare
      // "/admin" would land on /app/admin and a redirect loop (blank screen).
      if (fn === "endImpersonation") navigate("~/admin");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="sticky top-0 z-20 flex items-center justify-between gap-3 bg-brandorange px-4 py-1.5 text-xs font-medium text-white">
      <span>Viewing as this company's owner · {left} left</span>
      <span className="flex gap-3">
        <button className="underline disabled:opacity-50" disabled={busy} onClick={() => void act("extendImpersonation")}>
          Extend 30 min
        </button>
        <button className="underline disabled:opacity-50" disabled={busy} onClick={() => void act("endImpersonation")}>
          Exit
        </button>
      </span>
    </div>
  );
}
